export const tr = {
    'approx-price-lower-boundary-label': "{approxPrice}'den itibaren",
    'info-line': 'Fiyat ve süre yaklaşıktır ve uzmanın verileri dikkate alınarak belirtilir'
};
